import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { mapToVoid } from '@examdojo/core/rxjs';
import { ErrorHandlerService } from '@examdojo/error-handling';
import { of, take } from 'rxjs';
import { ClassQuery } from '../class/class.query';
import { ClassStudentQuery } from './class-student.query';
import { ClassStudentService } from './class-student.service';

export const classStudentResolver: ResolveFn<void> = () => {
  const classStudentService = inject(ClassStudentService);
  const classStudentQuery = inject(ClassStudentQuery);
  const classQuery = inject(ClassQuery);
  const errorHandler = inject(ErrorHandlerService);

  const classId = classQuery.getActiveId() || undefined;
  if (!classId) {
    return;
  }

  const hasStudentsForClass = classStudentQuery.getByClassId(classId).length > 0;

  return classStudentService.fetchByClassId(classId, { resetStore: !hasStudentsForClass }).pipe(
    errorHandler.catchHttpErrors(() => of(undefined)),
    take(1),
    mapToVoid(),
  );
};
